import { EnhancedAssessmentsCreatePage } from "pages/AssessmentsCreatePage"

const Detail = p => <EnhancedAssessmentsCreatePage {...p} isPreassessment />

export default Detail
